import { Modal } from "@general-backoffice/core";
import type { PaymentMethod } from "@investhinks/api-client";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import PaymentMethodSelect from "../paymentMethods/PaymentMethodSelect";

interface UpdateBotPaymentMethodModalProps {
  isOpen: boolean;
  close: () => void;
  update: (paymentMethodId: number | string) => void;
  isLoading: boolean;
}

const UpdateBotPaymentMethodModal = ({ isOpen, close, update, isLoading }: UpdateBotPaymentMethodModalProps) => {
  const { t } = useTranslation("bots", { keyPrefix: "updateBotPaymentMethodModal" });
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod | null>(null);

  return (
    <>
      <Modal.FormContainer
        title={t("title")}
        isOpen={isOpen}
        toggleOpen={close}
        closeText={t("closeBtn")}
        buttonSave={{ children: t("submitBtn"), disabled: isLoading || !paymentMethod }}
        isLoading={isLoading}
        onSubmit={() => {
          if (paymentMethod?.id) update(paymentMethod.id);
        }}
      >
        <PaymentMethodSelect
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          isDisabled={isLoading}
          required
        />
      </Modal.FormContainer>
    </>
  );
};

export default UpdateBotPaymentMethodModal;
